import { render, staticRenderFns } from "./CategoryVueSelect.vue?vue&type=template&id=2c85e376&scoped=true&"
import script from "./CategoryVueSelect.vue?vue&type=script&lang=js&"
export * from "./CategoryVueSelect.vue?vue&type=script&lang=js&"
import style0 from "./CategoryVueSelect.vue?vue&type=style&index=0&id=2c85e376&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c85e376",
  null
  
)

export default component.exports